import DictionaryClass from 'public/DictionaryClass'
import other from "manager/other"
export default {
  namespaced: true,
  state: () => ({
    o_Dictionary: new DictionaryClass()
  }),
  getters: {
    yhdj() {
      return JSON.parse(localStorage.getItem("Dictionary/yhdj"));
    },
    yhlx() {
      return JSON.parse(localStorage.getItem("Dictionary/yhlx"));
    },
    yhScore() {
      return JSON.parse(localStorage.getItem("Dictionary/yhScore"));
    }
  },
  actions: {
    async initDictionary({ state }) {
      return state.o_Dictionary.p_getChapter();
    },
    async getYhdj({ state }) {
      let res = await state.o_Dictionary.p_getchapter('yhdj');
      if(res !== undefined) {
        let config = res.data.data.list;
        localStorage.setItem("Dictionary/yhdj", JSON.stringify(
          config.map(({ name, value }) => ({ label: name, value })))
        );
      }
    },
    async getYhlx({ state }) {
      let res = await state.o_Dictionary.p_getchapter('yhlx');
      if(res !== undefined) {
        let config = res.data.data.list;
        localStorage.setItem("Dictionary/yhlx", JSON.stringify(
          config.map(({ name, value }) => ({ label: name, value })))
        );
    }
    },
    async getYhScore({ state }) {
      let res = await other.getByCompanyIdAndSign({
        companyId: JSON.parse(localStorage.getItem("user")).companyId,
        sign: "ranking"
      })
      switch (res.data.data.flag) {
        case 0:
          localStorage.setItem("Dictionary/yhScore", JSON.stringify([{
            label: '1分',
            value: 1
          }, {
            label: '2分',
            value: 2
          }, {
            label: '3分',
            value: 3
          }]));
          break;
        case 1:
          localStorage.setItem("Dictionary/yhScore", JSON.stringify([{
            label: '好',
            value: 1
          }, {
            label: '一般',
            value: 2
          }, {
            label: '差',
            value: 3
          }]));
          break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Dictionary.js